import styled from 'styled-components';

import {
  getSpace,
  getColor,
  getTextType,
  mq,
  px2rem,
  borderShape
} from '../../../../../stylesheets/tools';

const StyledFilter = styled.div`
  transition: all 0.3s ease-in-out;
  position: relative;

  .input-wrapper {
    position: relative;
    padding-bottom: ${getSpace('xs')};

    .tags {
      position: absolute;
      top: 54px;
      left: ${getSpace('xxs')};
      z-index: 1;
    }

    .input__inner {
      padding: ${getSpace('xxs')};
      ${borderShape()};
      border-radius: 0;

      input {
        padding: 0;
        ${getTextType('subline')}
        font-size: ${px2rem('16px')} !important;

        &::placeholder {
          ${getTextType('subline')}
          font-size: ${px2rem('16px')} !important;
          text-transform: none;
        }
      }
    }

    .search--hasTerm {
      input {
        color: transparent;
      }
    }
  }

  .tags {
    display: flex;
    padding: 0 0 ${getSpace('xs')} 0;
    gap: ${getSpace('xxxs')};
    flex-wrap: wrap;
    overflow: hidden;

    .filter-tag {
      cursor: pointer;
      user-select: none;
    }
  }

  .time-period {
    display: grid;
    grid-gap: ${getSpace('xxxs')};
    grid-template-columns: 1fr 1fr;

    ${mq('m')} {
      grid-template-columns: 1fr;
    }

    ${mq('xl')} {
      grid-template-columns: 1fr 1fr;
    }

    .react-date-picker {
      width: 100%;

      &__wrapper {
      height: ${getSpace('xl')};
      }
    }

    &--error {
      .react-date-picker__wrapper {
        background-image: linear-gradient(180deg, red, red), linear-gradient(225deg, red, red),
          linear-gradient(0deg, red, red), linear-gradient(90deg, red, red),
          linear-gradient(135deg, transparent 7px, red 7px, red 9px, transparent 9px);
      }
    }
  }

  .clear {
    color: ${getColor('teaserPink')};
    text-decoration: underline;
    cursor: pointer;
    user-select: none;
    margin: 0;
    margin-top: ${getSpace('s')};
  }

  .content-types {
    padding: ${getSpace('xs')} 0;
    user-select: none;

    [role='button'] {
      cursor: pointer;
    }

    &__tags {
      display: flex;
      flex-wrap: wrap;
      gap: ${getSpace('xxs')};
      padding: ${getSpace('xxs')} 0 0;
    }

    .icon-wrapper {
      display: flex;
      align-items: center;
    }

    .type-toggle-wrapper {
      cursor: pointer;

      &[disabled] {
        opacity: 0.4;
      }

      p {
        margin: 0;
      }
    }

    .type-toggle-icon {
      display: inline-block;
      vertical-align: text-bottom;
      ${getTextType('subline')};
      font-size: 32px !important;
      padding-right: 6px;
      color: ${getColor('black')};
    }

    .type-toggle-copy {
      display: inline-block;
      color:${getColor('black')};
      ${getTextType('subline')}
      font-size: ${px2rem('16px')} !important;
    }
  }

  .filter-dates__warning {
    color: red;
  }

  .filter-dates__label {
    ${getTextType('subline')}
    font-size: ${px2rem('16px')} !important;
    margin: 0;
    margin-bottom: ${getSpace('xxxs')};
  }
`;

export default StyledFilter;
